import { createFileRoute } from "@tanstack/react-router";
import AdminQueryPage from "@/admin/pages/query";

export const Route = createFileRoute("/admin/query")({
  component: AdminQueryPage,
});
